import IncidentManager from "../incidents/Manager";

export const subscriptionKeys = {};

// Priority in relation to severity
export const TACTICS_PRIORITY = [
  {id: "TA0043", title: "Reconnaissance"},
  {id: "TA0042", title: "Resource Development"},
  {id: "TA0001", title: "Initial Access"},
  {id: "TA0002", title: "Execution"},
  {id: "TA0003", title: "Persistence"},
  {id: "TA0004", title: "Privilege Escalation"},
  {id: "TA0005", title: "Defense Evasion"},
  {id: "TA0006", title: "Credential Access"},
  {id: "TA0007", title: "Discovery"},
  {id: "TA0008", title: "Lateral Movement"},
  {id: "TA0009", title: "Collection"},
  {id: "TA0011", title: "Command and Control"},
  {id: "TA0010", title: "Exfiltration"},
  {id: "TA0040", title: "Impact"}
];

class Manager {
  constructor() {
    this.subscriptionKeys = subscriptionKeys;
    this.TACTICS_PRIORITY = TACTICS_PRIORITY;
  }

  //Incident with tactics: incident-53e4784f-d3a3-4dab-9a9f-0813b86c40b5
  getIncident(id) {
    return IncidentManager.getIncidentById(id);
  }

  getIncidentTactics(...args) {
    return IncidentManager.getIncidentTactics(...args);
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonXDRManager) {
    window.atsSecurityRibbonXDRManager = new Manager();
  }
  return window.atsSecurityRibbonXDRManager;
};

export default Configuration();

export const ManagerClass = Manager;
